import { OidcProvider } from './providers'

// The snowplow signin/signup schemas take a closed union with no `sso` member
// (@luxuryescapes/contract-data-event-schemas), so SSO has to bucket as `email`
// here. The provider itself rides on the action's `oidcProvider` and is emitted
// as its own client event from userMiddleware — that's what to read for a
// per-client breakdown. Swap `sso` over once the contract carries it.
const ANALYTICS_SOURCE: Record<OidcProvider, App.AuthSource> = {
  password: 'email',
  google: 'google',
  sso: 'email',
}

export const analyticsSourceForProvider = (provider: OidcProvider): App.AuthSource =>
  ANALYTICS_SOURCE[provider]
